export default __webpack_public_path__ + "static/media/authority.410e7c53.png";